import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl, SanitizeHtml } from '@bd/bdcore-utilities';
import LightBox from '@bd/bdui-lightbox';
import { colors } from '../styles';

const styles = css`
  padding: 30px 0;
  background-color: ${colors.neutral};
  @media (min-width: 992px) {
    padding: 90px 0;
  }
  .PageIntroBanner_heading {
    font-size: 40px
    line-height: 46px;
    margin: 0;
    padding: 0 45px 0 0;
    &::after {
      content: '';
      width: 100px;
      height: 3px;
      position: relative;
      display: block;
      background-color: ${colors.brand1};
      margin: 30px 0;
    }
  }
  .PageIntroBanner_body {
    font-weight: 300;
    font-size: 20px;
    line-height: 40px;
    @media (min-width: 992px) {
      font-size: 18px;
      line-height: 34px;
      margin: 0 0 30px 0;
      padding: 0 45px 0 0;
    }
  }
  .PageIntroBanner_image {
    display: flex;
    background-size: cover;
    background-position: center center;
    width: 100%;
    min-height: 280px;
    margin: 0 0 30px 0;
    @media (min-width: 768px) {
      margin: 0;
      min-height: 460px;
    }
  }
  .PageIntroBanner_videoWrapper {
    width: 100%;
    position: relative;
    justify-content: center;
    align-items: center;
    background-position: center center;
    background-size: cover;
    min-height: 300px;
    margin: 0 0 30px 0;
    @media (min-width: 992px) {
      margin: 0;
      min-height: 460px;
    }
  }
  .PageIntroBanner_videoButton {
    cursor: pointer;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-image: url("/images/icon-play-button-pink-solid.svg");
    background-position: center center;
    background-size: 90px 90px;
    background-repeat: no-repeat;
    display: block;
  }
`;

const videoCss = css`
  margin: 10vh auto 0;
  @media (min-width: 992px) {
    width: 75vw;
    margin: 10vh auto 0;
  }
`;

function PageIntroBanner({ headline, body, image, video, videoThumbnail }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row justify-content-center">
          {
            video && !image &&
            <div className="col-lg-7 order-lg-2">
              <div
                className="PageIntroBanner_videoWrapper"
                role="button"
                tabIndex="0"
                style={{ backgroundImage: `url(${buildThumbnailUrl(videoThumbnail, { width: 1200, height: 1200, preserve: true })})` }}
              >
                <LightBox
                  items={[
                    {
                      element: (
                        <div
                          className={`${videoCss} embed-responsive embed-responsive-16by9`}
                          dangerouslySetInnerHTML={SanitizeHtml(video)}
                        />
                      ),
                    },
                  ]}
                >
                  <span className="PageIntroBanner_videoButton" />
                </LightBox>
              </div>
            </div>
          }
          {
            !video && image &&
            <div className="col-lg-7 order-lg-2">
              <div
                className="PageIntroBanner_image"
                style={{ backgroundImage: `url(${buildThumbnailUrl(image, { width: 1200, height: 1200, preserve: true })})` }}
              />
            </div>
          }
          <div className="col-lg-5 order-lg-1">
            <h2 className="PageIntroBanner_heading">{headline}</h2>
            <div className="PageIntroBanner_body" dangerouslySetInnerHTML={SanitizeHtml(body)} />
          </div>
        </div>
      </div>
    </div>
  );
}

PageIntroBanner.propTypes = {
  headline: PropTypes.string,
  body: PropTypes.string,
  image: PropTypes.string,
  video: PropTypes.string,
  videoThumbnail: PropTypes.string,
};

PageIntroBanner.defaultProps = {
  headline: undefined,
  body: undefined,
  image: undefined,
  video: undefined,
  videoThumbnail: undefined,
};

export default PageIntroBanner;



// WEBPACK FOOTER //
// ./src/components/PageIntroBanner.js